import type { GameState } from '@familyhub/shared';

/**
 * The guess grid — `maxAttempts` rows of `wordLength` tiles. Filled rows come
 * from the game state (letter + evaluated colour); the one active row shows what
 * is being typed (letters, no colour yet); the rest are empty.
 */
export function Board({
  state,
  current,
  shake,
}: {
  state: GameState;
  /** The in-progress row's letters, before submit. */
  current: string;
  /** Shake the active row — an invalid or too-short guess. */
  shake: boolean;
}) {
  const { wordLength, maxAttempts } = state.config;
  const activeRow = state.status === 'in_progress' ? state.guesses.length : -1;

  return (
    <div className="wl-board" role="grid" aria-label="Speelbord">
      {Array.from({ length: maxAttempts }, (_, r) => {
        const guess = state.guesses[r];
        const evaluation = state.evaluations[r];
        const isActive = r === activeRow;
        return (
          <div
            className={`wl-row${isActive && shake ? ' wl-row-shake' : ''}`}
            role="row"
            key={r}
          >
            {Array.from({ length: wordLength }, (_, c) => {
              const letter = guess ? guess[c] : isActive ? current[c] : undefined;
              const tileState = evaluation ? evaluation[c] : undefined;
              return (
                <div
                  key={c}
                  role="gridcell"
                  className="wl-tile"
                  data-state={tileState}
                  data-filled={letter ? 'true' : undefined}
                >
                  {letter ?? ''}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
